export const paths = {
  root: '/',
  login: '/login',
  register: '/register',
  verifyPhone: '/verify',
  /** Public: an invited user or driver enters their code and chooses a password. */
  acceptInvite: '/invite',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',

  onboarding: '/onboarding',
  /** The post-sign-in landing: the modules this person may use. */
  modules: '/modules',
  dashboard: '/dashboard',
  organizations: '/directory/organizations',
  applications: '/directory/applications',
  application: (id = ':id') => `/directory/applications/${id}`,
  organization: (id = ':id') => `/directory/organizations/${id}`,
  organizationNew: '/directory/organizations/new',
  organizationEdit: (id = ':id') => `/directory/organizations/${id}/edit`,
  myOrganization: '/my-organization',
  organizationTypes: '/reference/organization-types',
  licenses: '/directory/licenses',
  users: '/access/users',
  roles: '/access/roles',
  specialties: '/reference/specialties',
  /** The eighteen governorates — seeded by migration, read-only here. */
  governorates: '/reference/governorates',
  /** How fresh the two external register mirrors are, and every import run. */
  registerImports: '/reference/register-imports',
  doctors: '/clinic/doctors',
  patients: '/clinic/patients',
  patientLookup: '/clinic/patients/lookup',
  patient: (id = ':id') => `/clinic/patients/${id}`,
  visits: '/clinic/visits',
  visit: (id = ':id') => `/clinic/visits/${id}`,
  visitPrint: (id = ':id') => `/clinic/visits/${id}/print`,
  /** The consultation screen: a visit and its prescription in one act. */
  consultationNew: '/clinic/consultation/new',
  consultation: (id = ':id') => `/clinic/consultation/${id}`,
  /**
   * The printable prescription sheet. There is no prescriptions list or detail
   * page any more (owner's call, 2026-09-28): a prescription is read on the
   * visit that issued it and consumed at the pharmacy counter, and the only
   * standalone surface it keeps is the patient's document.
   */
  prescriptionPrint: (id = ':id') => `/clinic/prescriptions/${id}/print`,
  pharmacy: '/pharmacy',
  /** The dispensing log — a pharmacy's own fills (and the platform's view of all). */
  dispenses: '/pharmacy/dispenses',
  /** The same log from the prescribing side: the fills of this clinic's prescriptions. */
  clinicDispenses: '/clinic/dispenses',
  drivers: '/fleet/drivers',
  driver: (id = ':id') => `/fleet/drivers/${id}`,
  vehicles: '/fleet/vehicles',
  gpsDevices: '/fleet/gps-devices',
  /** The live fleet map — platform fleet staff only, like the whole module. */
  fleetMap: '/fleet/map',
  /** Wialon units, and the vehicle each one is linked to. */
  trackingUnits: '/fleet/tracking-units',
  deliveries: '/logistics/deliveries',
  deliveryNew: '/logistics/deliveries/new',
  delivery: (id = ':id') => `/logistics/deliveries/${id}`,
  deliveryPrint: (id = ':id') => `/logistics/deliveries/${id}/print`,
  deliveryEdit: (id = ':id') => `/logistics/deliveries/${id}/edit`,
  notifications: '/notifications',
  auditLog: '/reference/audit-log',
  profile: '/profile',
  settings: '/settings',
  forbidden: '/forbidden',
} as const;
